export default "__VITE_ASSET__BPDAHVWK__"